import { render, staticRenderFns } from "./TopSellerSlider.vue?vue&type=template&id=48884a7b&scoped=true"
import script from "./TopSellerSlider.vue?vue&type=script&lang=js"
export * from "./TopSellerSlider.vue?vue&type=script&lang=js"
import style0 from "./TopSellerSlider.vue?vue&type=style&index=0&id=48884a7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48884a7b",
  null
  
)

export default component.exports